import { NavLink } from "react-router-dom";
import { Icon, type IconName } from "./Icon";
import { useAuth } from "../auth/AuthContext";

interface RailItem {
  to: string;
  icon: IconName;
  label: string;
  hint: string;
}

const PRIMARY_ITEMS: RailItem[] = [
  { to: "/anfragen", icon: "inbox", label: "Anfragen", hint: "I" },
  { to: "/stammdaten", icon: "data", label: "Stammdaten", hint: "S" },
  { to: "/health", icon: "pulse", label: "Health", hint: "H" },
];

export function SideRail() {
  const { state, logout } = useAuth();
  const username =
    state.status === "authenticated" ? state.username : "—";
  const handleLogout = () => {
    logout().then(() => {
      // Hard-Reload, damit alle in-flight-States verworfen werden und das
      // AuthGate sauber auf die Login-Seite zurückfällt.
      window.location.href = "/";
    });
  };
  return (
    <aside className="rail">
      <div className="rail-top">
        <div className="rail-logo">
          <Icon name="logo" size={28} />
        </div>
        <div className="rail-brand">
          <div className="rail-brand-name">bidi·handel</div>
          <div className="rail-brand-tag uppercase-mini" style={{ letterSpacing: "0.18em" }}>
            INNENDIENST
          </div>
        </div>
      </div>

      <nav className="rail-nav">
        {PRIMARY_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `rail-item ${isActive ? "active" : ""}`}
            title={item.label}
          >
            {({ isActive }) => (
              <>
                <span className="rail-item-icon">
                  <Icon name={item.icon} size={18} />
                </span>
                <span className="rail-item-label">{item.label}</span>
                <span className="rail-item-hint mono">{item.hint}</span>
                {isActive && <span className="rail-item-spine" aria-hidden />}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="rail-bottom">
        <button
          type="button"
          className="rail-item"
          title={`Angemeldet als ${username} — abmelden`}
          onClick={handleLogout}
        >
          <span className="rail-item-icon">
            <Icon name="user" size={18} />
          </span>
          <span className="rail-item-label">{username}</span>
          <span className="rail-item-hint mono">Logout</span>
        </button>
      </div>
    </aside>
  );
}
